import {OpeningLogiCtrlStatus} from "../../../../../api/Openings";
import {
    CircularProgress, Divider, IconButton,
    Typography
} from "@mui/material";
import {useAsync2} from "nate-react-api-helpers";
import {api} from "../../../../../api/API";
import {Close} from "@mui/icons-material";
import {HwRulesTab} from "./HwRulesTab";
import {Popover} from "../../../../../misc/Popover";
import {useProjectId} from "../../ProjectName";

export function LogiCtrlHwModal(props: {
    anchorEl: HTMLElement | null;
    onClose: () => void;
    openings: number[];
    value: OpeningLogiCtrlStatus
    name: string;
    onReload?(): void;
}) {

    const projectId = useProjectId();

    const rulesReq = useAsync2((input) => {
        return api.logiCtrl.listHwRuleSummary(input)
    }, {openings: props.openings}, [props.openings]);

    const statusReq = useAsync2((input) => {
        return api.logiCtrl.listHwStatusSummary(input)
    }, {openings: props.openings, project: projectId}, [props.openings, projectId]);

    const ready = !rulesReq.loadingOrError && !statusReq.loadingOrError;

    return (
        <Popover open anchorEl={props.anchorEl} onClose={props.onClose}
                 slotProps={{paper: {sx: {borderRadius: 2, minWidth: 240}}}}>

            <div style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "8px 8px 4px 12px",
            }}>
                <div style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 4,
                }}>
                    <Typography variant="subtitle2" color="text.secondary">Logistics Status: HW {props.name}</Typography>
                    {!ready && <CircularProgress size="1em" />}
                </div>
                <IconButton size="small" onClick={props.onClose} sx={{padding: "2px"}}>
                    <Close sx={{fontSize: 16}} />
                </IconButton>
            </div>
            <Divider />
            {rulesReq.error ? rulesReq.LoadingOrErrorElement : null}
            <HwRulesTab
                value={props.value}
                openings={props.openings}
                onClose={props.onClose}
                onReload={props.onReload}
                ready={ready}
                rules={rulesReq.asList}
                statuses={statusReq.asList}
            />
        </Popover>
    )
}
